import { FormControl, FormHelperText, FormLabel, Typography } from '@mui/joy';

import { SecretInput } from '@/components/SecretInput';

import { OPTIONAL_MODEL_SECRETS } from '../Playground.constants';

export function PlaygroundSecretInput(props: {
  value?: string;
  onChange: (value: string) => void;
  error?: string;
  name: string;
}) {
  return (
    <FormControl error={!!props.error}>
      <FormLabel className="flex items-center gap-2">
        <Typography fontSize={16} fontFamily="'Fira Code', monospace">
          {props.name}
        </Typography>
        {OPTIONAL_MODEL_SECRETS.includes(props.name) && (
          <span className="text-xs text-neutral-500">Optional</span>
        )}
      </FormLabel>

      <SecretInput
        data-testid={`playground-secret-input-${props.name}`}
        value={props.value ?? ''}
        onChange={(e) => props.onChange(e.target.value)}
      />

      {props.error && <FormHelperText>{props.error}</FormHelperText>}
    </FormControl>
  );
}
